module.exports = __webpack_public_path__ + "static/media/cornell_logo.75e18268.svg";